<template>
  <div class="adminPage">

    <div class="titlePage">
      Caracterización
    </div>

    <va-notification
      v-if="noDtaForm"
      color="danger"
      class="refNoData"
    >
      No se encuentran formularios activos en este momento.
    </va-notification>

    <div v-if="!noDtaForm" class="adminCard">

      <Shortcuts :InfoView="shortcutsData" />

    </div>

  </div>
</template>
<script>
import IberoHelpers from '@/store/helpers.js'
import Shortcuts from '../dashboard/Shortcuts.vue'

export default {
  name: 'refCharac',

  components:{
    Shortcuts
  },

  data () {
    return {
      listCarat: [],
      noDtaForm: false,
    }
  },

  computed:{
    shortcutsData(){
      return this.listCarat.map(item => ({
        id: item.Id_Characterization,
        title: item.Nam_Characterization,
        img: item.Img_Characterization,
        link: 'FormCharacterization/' + item.Id_Characterization,
        target: '_self'
      }))
    }
  },

  created () {
    let loader = this.$loading.show()

    IberoHelpers.getListCaracterizacion(this.$store, 1)
      .then(Response => {

        if (Response.data === '') {
          this.noDtaForm = true
        } else {
          this.listCarat = Response.data.Characterizations
          this.noDtaForm = false
        }

        loader.hide()
      })
  },
}
</script>